import React from 'react';
import { useSuspense } from '@rest-hooks/react';
import { useParams } from 'react-router-dom';

import OrganizationResource from 'resources/organization/OrganizationResource';

import EventsList from './EventsList';
import AIEventChat from './AIEventChat';

import Layout from 'components/layouts/index'
import TabPanels from 'components/TabPanels';
import AlertCta from 'components/AlertCta';
import LocationCheckModal from 'components/LocationCheckModal';

const pageInfo = {
  name: 'Events',
  description: 'Create and organize your organization events here',
  action: true
};

const Events = () => {

  const params = useParams();
  const organizationId = params.organizationId;

  const organization = useSuspense(OrganizationResource.detail(), { id: organizationId });

  const {slug, logo_url, stripe_charges_enabled, eupago_charges_enabled} = organization;
  const noChargesEnabled = (!stripe_charges_enabled && !eupago_charges_enabled);

  return (
    <Layout context='teacher'
            activeMenuItem='events'
            pageInfo={pageInfo}
            cta={
              <AlertCta
                primaryText={"Your next event: "}
                externalUrl={`${window.location.origin}/${slug}/events/next`}
                qrCodeTitle={"Your next event"}
                qrCodeimage={logo_url}
              />
            }>
      <TabPanels labels={["Upcoming Events", "Past Events"]}>
        <EventsList upcoming={true} noChargesEnabled={noChargesEnabled}/>
        <EventsList past={true} />
      </TabPanels>

      <LocationCheckModal organization={organization} />
      {organizationId === '1' && <AIEventChat />}
    </Layout>
  )
};

export default Events;
